module.exports = __webpack_public_path__ + "img/7.18da01ed.jpg";